module.exports = __webpack_public_path__ + "static/img/img10-1.e7a769d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img10-1.png
// module id = j1mA
// module chunks = 0